import upsell from './upsell/en';
import crossSell from './cross-sell/en';

export default {
  layout: {
    configuration: 'Configuration',
    dashboard: 'Dashboard',
    hotels: 'Hotels',
    forms: 'Forms',
    appearence: 'Appearence',
    pms: 'PMS',
    sales: 'Checkin channels',
    payment: 'Payment channels',
    documents: 'Legal Documents',
    language: 'Languages and literals',
    users: 'Team',
    checkin: 'Check-in',
    checkout: 'Check-out',
    booking: 'Reservations',
    paymentMethods: 'Payment Methods',
    billing: 'Billing info',
    subscriptions: 'Subscriptions',
    doorOpening: 'Door opening',
    doorOpeningConfig: 'Platform configuration',
    doorMapping: 'Door mapping',
    stats: 'Summary',
    account: 'My Account',
    communicationChannels: 'E-mail templates',
    accountDetail: 'Account details',
    marketing: 'Marketing',
    support: 'Support',
    quickguide: 'Start quickguide',
    guestlink: 'Guestlink',
    mailTemplates: 'Email templates',
    smtpConfig: 'SMTP configuration',
    paymentList: 'Payments',
    paperlessPush: 'Paperless push',
    cardex: 'Checkin report',
    custom_cardex_pdf: 'Entry part',
    terms: 'Terms and Conditions',
    'data-privacy-policy': 'Privacy Policy',
    'loyalty-program': 'Loyalty Program',
    'data-commercial-use': 'Commercial Use',
    policeReport: 'Traveler registration',
    policeReportConfig: 'Police report configuration',
    billingConfig: 'Billing',
    upsell: 'Upselling',
    crossSell: 'Cross-selling',
    moduleActivation: 'Module activation',
    sessionExpired: 'Your session has expired due to inactivity.',
    sessionWillExpire: 'Your session will end in # minutes. Make sure to save any changes.',
    closeInactivityMessageButton: 'Go back to save changes',
    login: 'Log in',
    infoText: 'Information texts',
    startCheckin: 'Start of check-in',
    endCheckin: 'End of check-in',
    SFTP: 'Checkin SFTP',
    policeReportPlatform: 'Submission platform',
    policeReportRH: 'Reservation report',
    policeReportPV: 'Traveler report',
    policeReportList: 'Reports panel',
    hcn: 'HCN',
    hbxAutoInvoice: 'Invoice Automation',
  },
  hbxProducts: {
    missingSubscriptionHcn: {
      title: 'Get license',
      description:
        "You can set up HCN for the hotel by activating the 'HCN' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
    missingSubscriptionAutoInvoice: {
      title: 'Get license',
      description:
        "You can set up Invoice Automation for the hotel by activating the 'Invoice Automation' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
    enableButton: 'Enable',
    disableButton: 'Disable',
    enableProduct: 'The  %s product has been activated',
    disableProduct: 'The %s product has been disabled',
    errorMessage: 'An error occurred when activating or deactivating the product.',
    adviceDisableProduct: '⚠️ Disabling the Product',
    adviceDisableProductText: 'You are going to disable the %s product. Are you sure?',
    pmsInvalidMessage: {
      title: 'Invalid PMS for the product',
      description1: 'The PMS %s is not configured to support the product ',
      description2: 'These are the PMS with which the product can be used:',
    },
    disable: 'Disable',
    cancel: 'Cancel',
  },
  confirm: 'Confirm',
  save: 'Save',
  create: 'Create',
  deleteAccount: 'Delete account',
  cancel: 'Cancel',
  search: 'Search',
  add: 'Add',
  yes: 'Yes',
  no: 'No',
  setup: 'Connect',
  checkinPreview: 'Checkin Preview',
  logout: 'Log out',
  state: 'State',
  hotel: 'Hotel',
  pms: 'PMS',
  id: 'ID',
  resetForm: 'Reset form',
  family_relationship:
    'If marked as mandatory, the field will only be required for the reservation holder when there are children included.',
  document_support_number:
    'If marked, the field will only be required for DNI or Residence Permit; for other document types, it will be visible but optional.',
  province: 'If the country is not visible/mandatory, the province will be a free text field.',
  city: 'If the province is not visible/mandatory, the city will be a free text field.',
  fieldInfoByPMS: {
    Timon: {
      address: 'Limited to 35 characters by the PMS.',
    },
    Winhotel: {
      name: 'Limited to 15 characters by the PMS.',
      surname: 'Limited to 15 characters by the PMS.',
      second_surname: 'Limited to 15 characters by the PMS.',
      address: 'Limited to 50 characters by the PMS.',
    },
    Sihot360: {
      province: 'Sihot360 only supports Spanish provinces.',
    },
    GuestPortal: {
      name: 'The total length of name and surnames is limited to 30 characters by the PMS.',
      surname: 'The total length of name and surnames is limited to 30 characters by the PMS.',
      second_surname:
        'The total length of name and surnames is limited to 30 characters by the PMS.',
      province: 'Quohotel only supports Spanish provinces.',
    },
    Ohip: {
      address: 'Limited to 80 characters by the PMS.',
    },
    Noray_htl: {
      province: 'Noray_htl only supports Spanish provinces.',
    },
  },
  pmsPopup: {
    title: '¡Perfect!',
    subtitle: 'You have just registered your property',
    legalTextNewHotel:
      'The Entry Part and the Checkin Report in English and Spanish have been successfully saved',
    text: 'Now you can optimize the process by connecting your PMS',
    button: 'PMS Setup',
  },
  hotelSelector: {
    onlyTo: 'Only to:',
    applyToAllHotels: 'All hotels',
    allHotels: 'All hotels',
    hint: 'Enter the name of the hotel',
    info: 'Select Hotel:',
  },
  channel: 'Channel',
  checkins: 'Checkins',
  appearence: {
    checkInTitle: 'Online Check-In Appearance',
    logo: 'Logo',
    mainColor: 'Main color',
    secondaryColor: 'Secondary color',
    bgColor: 'Background Color',
    kioskTitle: 'Kiosk Appearance',
    mainColorKiosk: 'Kiosk main color',
    kioskBg: 'Background color Kiosk',
    kioskLogo: 'Logo de Kiosk',
    success: 'Appearence updated successfully',
    languageSuccess: 'Languages updated successfully',
    apply: 'Apply styles',
    languageTitle: 'Select the languages you need',
    imageSliderTitle: 'T-paperless rest carousel',
    upload: 'Add',
    imageSliderDesc:
      'Here you can configure the images that will be displayed in the carousel. You can add up to 5 images',
    logoError: 'There was an error uploading the logo',
    applyAppearenceHotels: 'Save %s appearance for hotels',
    applyImagesSliderHotels: 'Save carousel for hotels',
    imageSaveSuccess: 'Carousel image updated',
    imageRemoveSuccess: 'Carousel image removed',
    imageError: 'Error saving images by hotel',
    imageSaveError: 'Error saving carousel images',
    imageRemoveError: 'Error removing carousel images',
  },
  login: {
    header: 'Please enter your login information',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    loginButton: 'Login',
    registerButton: 'Create new account',
    forgotPassword: 'Forgot your password?',
    blockedAccount:
      'Your account has been locked due to too many login attempts. Use the following link to unlock it:',
    blockedAccountLinkLabel: '🔓 How to unlock a user in the Civitfun Dashboard',
    blockedAccountLinkHref:
      'https://academy.civitfun.com/hc/es/articles/26709560196509--C%C3%B3mo-desbloquear-un-usuario-en-el-Dashboard-de-Civitfun',
    maxFailedAttempts:
      'Incorrect username or password. You have # attempts remaining before your account is locked.',
    error: 'Error logging in',
  },
  validateLogin: {
    header: 'Two-Step Verification',
    description: 'Enter the verification code you received in your email',
    button: 'Send',
    error: 'Error validating the code',
  },
  register: {
    title: 'Account information',
    chain: 'Hotel Chain Name',
    name: 'Name',
    phone: 'Phone',
    mail: 'Email',
    password: 'Password',
    repeatPassword: 'Repeat password',
    termsConditions: 'I have read and accept the privacy policy and terms and conditions',
    button: 'Create account',
    emptyFields: 'You must fill in all fields in the form',
    matchPasswords: 'The passwords do not match',
    invalidMail: 'The email address is invalid',
    termsError: 'You must accept the terms and conditions',
    registerOk:
      'Welcome to Civitfun, we have sent you an email to # to validate your registration. By clicking on "Add payment method" you will be redirected to configure a payment method.',
    registerKO: 'Failed to add payment method successfully',
    goBack: 'Return to login',
    goLogin: 'Go to login',
    addPaymentMethod: 'Add payment method',
  },
  recover: {
    header:
      'Enter the email address associated with your account and we will send you an email to recover your password.',
    invalidEmail: 'Enter a valid email address',
    send: 'Send',
    success: 'We have e-mailed your password reset link!',
  },
  changePassword: {
    header: 'Enter your new password',
    success: 'Password has been changed successfully',
  },
  validateUser: {
    success: '# registration has been completed successfully!',
  },
  bookingList: {
    nameAndSurnameCol: 'Name and surname',
    locatorCol: 'Locator',
    nameCol: 'Name',
    surnameCol: 'Surname',
    checkinCol: 'Entrance',
    checkoutCol: 'Departure',
    adultCol: 'Adults',
    childrenCol: 'Children',
    documentCol: 'Document',
    export: 'Export data',
    import: 'Import reservations',
    title: 'Reservations',
    statusCol: 'State',
    actionPop: 'See related checkins',
  },
  checkOutModule: {
    locatorCol: 'Locator',
    nameCol: 'Name',
    surnameCol: 'Surname',
    entranceDate: 'CheckIn',
    departureDate: 'CheckOut',
    title: 'Check-Out',
    export: 'Export Data',
    actions: 'Details',
    channelCol: 'Channel',
    date: 'Check-out',
    exportOk: 'Export of checkouts completed!',
    missingSubscription: {
      title: 'Get license',
      description:
        "You can set up Check-Out for the hotel by activating the 'Check-Out' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
  },
  bookingStatus: {
    BOOKED: 'Booked',
    UNCOMPLETED: 'Not completed',
    COMPLETED: 'Completed',
    CHECKEDOUT: 'Checked Out',
    CHECKEDIN: 'Checked In',
  },
  setUp: {
    searchFieldsTitle: 'Search form fields',
    searchFieldInfo:
      'If the check-in process is integrated with your PMS these fields will be configured automatically',
    checkInRequirement: 'Check-in process requirements',
    bookingSummary: 'Fields Displayed in Reservation Summary',
  },
  bookingSummary: {
    showBookingNumber: 'Booking Number',
    showHolderName: 'Holder',
    showArrivalDate: 'Arrival date',
    showDepartureDate: 'Departure date',
    showRoomName: 'Room',
    infoText:
      'The "room" field will show both the room number and type if available in the PMS at check-in. If only one is available, only that will be displayed.',
  },
  guestTable: {
    copyForm: 'Copy',
    copyFormTitle: 'Copy form configuration',
    copyFormDescription:
      'Select the hotels to which you want to configure the forms the same as the selected one.',
    copyFormConfigSuccess: 'Form configuration copied successfully',
    copyFormConfigPartialError: 'Error copying form configuration for hotels with ID: ',
    compatibilityLoadError: 'Error loading compatible hotels',
    fieldCol: 'Civitfun',
    fieldColPMS: 'PMS',
    visibleCol: 'Visible',
    mandatoryCol: 'Mandatory',
    success: 'The guest form configuration has been updated',
    error: 'Failed to update the guest form configuration',
    applyToAllWarning: 'The configuration will be applied to every hotel',
    languageSelector: 'Select the language of the fields',
    italyDesc:
      'This hotel is located in Italy, this field will be shown if the country of birth is Italy',
    italyResidencyDesc:
      'This hotel is located in Italy, this field will be shown if the country of residency is Italy',
    translationMissing: 'The translation for this field is missing for other languages',
    availableInPMS: 'Available in PMS',
    unavailableInPMS: 'Unavailable in PMS',
    requiresMappingInPMSCloudbeds: 'Requires mapping as:',
    requiresMappingInPMSOpera: 'Requires mapping with a UDF',
    requiresMapping: 'Requires mapping',
    requiresMappingDescription:
      'The field does not exist in your PMS, but you can create and map a custom one to populate it with the Civitfun data.',
    unavailableInPMSDescription:
      'The field does not exist in your PMS, so the data cannot be populated in it. However, you can enable it to view the data in the Civitfun dashboard.',
    activationModal: {
      unavailableInPMSTitle: 'Are you sure you want to activate this field?',
      activateField: 'Activate field',
      cancel: 'Cancel',
    },
    formVersion: {
      legacy: 'Legacy',
      hybrid: 'Hybrid',
      dynamic: 'Dynamic',
    },
    formVersionSelector: 'Form version',
    formVersionChangeTitle: 'Warning',
    formVersionChangeConfirmation:
      'If there are check-ins in progress, this change could cause critical errors. Make sure to perform it only during periods of low or no activity to avoid issues.',
  },
  checkInList: {
    stateOk: 'Processed correctly',
    stateError: 'Error detected',
    stateCol: 'State',
    status: {
      ok: 'Processed correctly',
      error: 'Field dump error',
      pending: 'Pending: It will be validated when all guests have completed check-in.',
    },
    locatorCol: 'Locator',
    typeCol: 'Type',
    nameCol: 'Name',
    surnameCol: 'Surname',
    checkinCol: 'CheckIn',
    checkoutCol: 'CheckOut',
    documentCol: 'Document',
    title: 'Check-In',
    export: 'Export Data',
    statePending: 'Pending',
    stateCheckin: 'Check In',
    stateCheckout: 'Check Out',
    actions: 'Detail',
    channelCol: 'Channel',
    checkinDate: 'Check In',
    popUp: {
      processingTitle: 'Processing',
      processingMessage: 'We are processing your request. Please wait.',
    },
    detail: {
      bookingDetail: 'Booking details',
      informationTitle: 'Information',
      documentsTitle: 'Documents',
      locator: 'Locator',
      checkin: 'Checkin',
      checkout: 'Checkout',
      holder: 'Holder',
      signedDocuments: 'Signed documentss',
      termsConditions: 'Terms and Conditions',
      cardex: 'Checkin report',
      guestDetail: 'Holder data',
      guest: {
        pmsValue: 'Value in PMS:',
        pmsFieldUnavailable: 'Field unavailable in PMS',
      },
      paymentDetail: 'Payment details',
      payment: {
        charges: 'Charges',
        operations: 'Operations',
        locator: 'Locator',
        amount: 'Amount',
        operation: 'Type',
        concept: 'Concept',
        paymentStatus: 'Payment state',
        warrantyStatus: 'Warranty status:',
        statusDivider: 'Status of payments',
        totalBalance: 'Total balance',
        operationPayment: 'Payment',
        operationTokenize: 'Warranty',
        operationPaymentTokenize: 'Payment and Warranty',
      },
    },
    missingSubscription: {
      title: 'Get license',
      description:
        "You can set up Check-In for the hotel by activating the 'Check-In' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
  },
  ihClient: {
    CIVITFUN: 'Civitfun',
    MTS: 'MTS',
    ROOMMATIK: 'Roommatik',
    BOOKINGDOTCOM: 'Booking.com',
    KIOSK: 'Auto Check-In Terminal',
    RECEPTION: 'Paperless Terminal',
    ['BOOKING.COM']: 'Booking.com',
  },
  salesChannels: {
    stateCol: 'State',
    hotelCol: 'Hotel',
    channelCol: 'Channel',
    actionCol: 'Action',
    identifierCol: 'Identifier',
    bookingIdHint: 'Booking.com hotel Id.',
    bookingTooltip:
      'What is this? You can find the ID of your property on Booking.com in your administration panel',
    tryFreeButton: 'Try it for free',
    success: 'Check-in channel successfully updated!',
    otaPopup: {
      title: 'Perfect!',
      text: 'All you have to do is activate the $OTA channel to start receiving check-ins',
      button: 'Activate $OTA',
    },
    activeGuestlink1: 'To enable Booking.com integration, ',
    activeGuestlink2: 'you need to configure your SMTP settings',
    paperlessUserHotelConfig: {
      title: 'Edit user',
      description: 'You can select all the hotels this paperless user will have access to',
      success: 'Configuration updated successfully.',
      error: 'Error updating the configuration',
    },
  },
  guestForms: {
    holder: 'Holder',
    adults: 'Adults',
    children: 'Children',
    applyToAllHotels: 'Apply to all hotels',
  },
  errorMessage: {
    dateRangeExport: 'Please select a date range to perform the export',
    guestDetail: "It's not possible to view the detail information at the moment",
  },
  hotels: {
    addNewHotel: 'Add a new hotel',
    title: 'Hotels',
    nameCol: 'Name',
    editCol: 'Edit',
    deleteCol: 'Delete',
    deleteWarningTitle: 'Delete',
    deleteWarning: 'Do you want to eliminate the hotel?',
    mapHint: 'Find your hotel on the Map',
    country: 'Country',
    address: 'Address',
    region: 'Region',
    addSuccess: 'Hotel # has been added',
    updateSuccess: 'The hotel # has been successfully updated',
    deleteSuccess: 'The hotel # has been removed',
    previewCheckin: 'My Online Check-in',
    integrated: 'Integrated',
    noIntegrated: 'No integrated',
    emptyTitle: 'Add your hotels',
    emptyDescription: 'To do so, just fill in the name field and look for your address on the map.',
    emptyName: 'You must add a name for the hotel',
    emptyLocation: 'You must add a location for the hotel',
    nif: 'NIF',
    establishmentType: 'Type of Property',
    roomCount: 'Number of Rooms',
    hasInternet: 'Has Internet Connection',
    city: 'City',
    postalCode: 'Postal Code',
    phone: 'Phone Number',
    email: 'Email',
    website: 'Website',
    designation: 'Fiscal name',
    adUrl: 'URL to identify the advertisement',
    hotelStatusId: 'Status (admin only)',
    atlasId: 'Atlas ID',
    statusId: {
      label_1: 'Created',
      label_2: 'Onboarding',
      label_3: 'Live',
      label_4: 'Out of licence',
      label_5: 'Lost',
      label_6: 'Demo',
      label_7: 'Pending',
    },
    uploadFile: 'Upload the file here',
    downloadTest: 'Download sample',
    createFileHotelsSuccess: 'Hotels created successfully',
  },
  legalDocuments: {
    deactivateButton: 'Deactivate',
    deactivateTitle: 'Deactivate',
    deactivateWarning:
      'Deactivating this field will delete all its content. This will apply to all languages of the selected hotel. The content of the current language has been copied to the clipboard in case you want to keep it.',
    deactivateWarningAlert: '⚠️ The action cannot be undone once confirmed.',
    termsConditions: 'Terms and Conditions',
    checkIn: 'Checkin report',
    commercialUse: 'Text check-box commercial use of data',
    preview: 'Preview',
    previewBtn: 'Preview',
    success: 'The text was successfully updated',
    error: 'An error occurred while updating the text.',
    warning: 'Templates loaded by default. They will not be registered until you save them',
    previewPlaceholder: 'Click on "preview" to see a preview of the document.',
    langSelectorHint: 'Select the language of the documents',
    terms: 'Terms and conditions',
    restoreDefault: 'Reset',
    restoreDefaultWarning: 'Unsaved data will be lost. Do you want to continue?',
    cardex: 'Checkin report',
    labelHint: 'The label or text next to the checkbox',
    'data-privacy-policy': 'Privacy Policy',
    'loyalty-program': 'Loyality program',
    'data-commercial-use': 'Commercial use data',
    custom_cardex_pdf: 'Entry part',
    checkin_template: 'Check-in confirmation mail template',
    checkout_template: 'Check-out confirmation mail template',
    fileNamePrefix: 'File name',
    optional: 'This option will be voluntary acceptance by the guest',
    mandatory: 'This option will be mandatory for the guest',
    dataPrivacyPolicy: 'Privacy Policy',
    loyaltyProgram: 'Loyalty Program',
    dataComercialUse: 'Commercial Use',
    checkboxes: 'Checkboxes',
    continue: 'Continue',
    sign: 'Sign',
    contractSign: 'Contract Signature',
    otherFields: 'Check-in fields',
    view: 'view',
    legalTexts: {
      title: 'Legal Texts',
      contract: 'Contract',
      viewContract: 'View Property Contract',
      entranceRegistration: 'Entry Registration',
      viewEntranceRegistration: 'View Entry Registration',
    },
    info: {
      checkBoxes:
        'Checkboxes will be available at the beginning of check-in and will appear when entering guest details. Clicking any of these will display the configured legal text.',
      legalTexts:
        'The legal text of the entry report and terms and conditions can be accessed when signing the check-in.',
      checkIn: 'The entry report will be sent by email along with the check-in confirmation.',
    },
    tagsErrors: {
      noValue: 'Tag has no value:',
      notSupported: 'Unsupported tag:',
      badFormat: 'Badly formatted tag:',
    },
    tags: {
      chain: 'Chain',
      chain_logo: 'Logo of the chain',
      chain_name: 'Chain name',
      hotel: 'Hotel',
      hotel_logo: 'Hotel logo',
      hotel_name: 'Hotel name',
      address: 'Address',
      hotel_phone: 'Hotel phone number',
      CIF: 'Company CIF of the hotel',
      CIF_postal_code: 'Postal code of the hotel company',
      CIF_address: 'Company address of the hotel',
      CIF_city: 'City of the hotel company',
      CIF_province: 'Province company of the hotel',
      CIF_country: 'Country of the hotel company',
      CIF_business_name: 'Company name of the hotel',
      CIF_business_email: 'Contact email of the hotel company',
      legal_cardex: 'Legal text on the entry part',
      legal_terms_and_conditions: 'Legal text about the property contract',
      legal_data_privacy_policy: 'Legal text about the data privacy policies',
      legal_data_commercial_use: 'Legal text about commercial use of data',
      legal_loyalty_program: 'Legal text about loyalty program membership',
      booking: 'Booking',
      reference_number: 'locator/voucher/voucher',
      booking_number: 'Booking Number',
      booking_identifier: 'unique identifier in the PMS',
      entrance_date: 'Entry date',
      departure_date: 'Departure date',
      entrance_time: 'Entry time',
      departure_time: 'Departure time',
      reservation_created_at: 'Reservation created date',
      nights: 'Number of nights',
      adults: 'number of adults',
      children: 'number of children',
      num_guests: 'total number of guests',
      email: 'email of the reservation',
      balance: 'price',
      agreed_price: 'Agreed price',
      booking_room: 'number of rooms',
      room_number: 'name of the assigned room',
      room_number_name: 'name of the room',
      room_type: 'Room Type',
      customer_notes: 'customer notes',
      agency_code: 'agency code',
      regime_stay: 'regime stay',
      guest_name: 'guest name',
      guest_nationality: 'guest nationality',
      document_number: 'guest document number',
      holder_signature: 'holder signature',
      police_report_number: 'Police report number',
      guest: 'guest',
      guest_first_name: 'First name',
      guest_surname: 'Last_name',
      guest_second_surname: 'Second Last Name',
      guest_gender: 'Gender',
      guest_birth_date: 'Date of birth',
      guest_nationality: 'Nationality',
      guest_document_type: 'Type of document',
      guest_document_number: 'Document number',
      guest_expedition_date: 'Date of expedition',
      guest_expiration_date: 'Expiration date',
      guest_email: 'Email',
      guest_phone: 'Phone',
      guest_address: 'Address',
      guest_postal_code: 'Postal Code',
      guest_city: 'City',
      guest_country: 'Country',
      guest_province: 'Province',
      guest_signature: 'Signature',
      data_privacy_policy: 'Privacy policy',
      data_commercial_use: 'Data usage',
      loyalty_program: 'Loyalty program',
      credit_card: 'Credit card',
      card_name: 'Card name',
      card_type: 'Card type',
      card_number: 'Card number (Last 4 digits)',
      card_expiration_date: 'Expiration date',
      link_ios: 'iOS Link',
      link_android: 'Android Link',
      guest_business_name: 'Business name',
      guest_business_number: 'Business number',
      guest_business_address: 'Business address',
      bracelet_id: 'Bracelet UDF',
      checkin_url: 'Checkin Link',
      establishment_type: 'Establishment type',
      hotel_designation: 'Fiscal name',
      hotel_room_count: 'Number of rooms',
      hotel_has_internet: 'Has internet',
      guest_landline_phone: 'Landline phone',
      guest_document_support_number: 'Document support number',
      guest_family_relationship: 'Family relationship',
      guest_payment_type: 'Payment type',
      hotel_web: 'Hotel website',
      hotel_ad_url: 'Ad url',
      bracelet_id: 'Bracelet UDF',
      hotel_slug: 'Hotel slug',
      checkin_date: 'Checkin date',
      confirmation_number: 'Confirmation number',
      signer: 'Name of legal guardian',
      payment_url: 'Payment url',
      guest_allow_telephone_contact: 'Telephone contact consent',
      door_opening_url: 'Door key generation url',
      upsell_id: 'Upselling ID',
      upsell_request_date: 'Upselling request date',
      upsell_state: 'Upselling state',
      original_room_type: 'Original room type',
      requested_room_type: 'Requested room type',
      upsell_price: 'Upselling price',
      payment_status: 'Payment status',
      payment_url: 'Payment Link',
      upsell_url: 'Upselling Link',
      guest_signature_date: 'Date of signature',
      cross_sell_url: 'Cross-sell Link',
      cross_sell_id: 'Cross-sell ID',
      cross_sell_request_date: 'Cross-sell request date',
      cross_sell_state: 'Cross-sell state',
      item_name: "Item's name",
      cross_sell_price: 'Cross-sell price',
      confirmation_number: 'Booking identifier',
      guest_document_country: 'Country of the document',
      guest_birth_city: 'City of birth',
      guest_occupation: 'Profession',
      guest_document_issuance_country: 'Country of issuance of the document',
      guest_document_issuance_city: 'City of issuance of the document',
      payment_type: 'Booking payment type',
      hotel_email: 'Hotel email',
      additional_services: 'Additional services',
      card_number_masked: 'Card number (masked)',
    },
    header_text: 'Massive duplication of ',
  },
  literals: {
    title: 'Fill in these fields to customize your texts',
  },
  stats: {
    total: 'Total',
    chart: {
      xTitle: 'Date',
      yTitle: 'Checkins',
      title: 'Checkin statistics',
    },
    avgDuration: {
      title: 'Average checkin time',
      subtitle: 'Average time taken by guest to check in',
      noData: 'No data ',
    },
    conversion: {
      title: 'Conversion',
      subtitle: 'Started checkins VS finished checkins',
      noData: 'No data',
    },
    mostCheckins: {
      title: 'Day and hour with most checkins',
      subtitle: 'Users check in more frequently on the days and at the times of day',
      noData: 'No data',
    },
    advance: {
      title: 'Checkin advance',
      subtitle: 'Users check in an average of one day before the check-in date.',
      noData: 'No data',
      days: 'Days',
      hours: 'Hours',
    },
    devices: {
      title: 'Main devices',
      phone: 'Phone',
      tablet: 'Tablet',
      desktop: 'Computer',
      unknown: 'N/A',
    },
  },
  pmsScreen: {
    title: 'PMS CONFIGURATION',
    defaultSelectorValue: 'Select a PMS',
    connectSuccess: 'Connection to the PMS has been established successfully',
    connectError: 'Error connecting to the PMS',
    testPms: 'Check connection',
    testPmsDesc: 'You can check the state of the PMS connection clicking on the Test PMS button',
    testBooking: 'Test booking',
    testBookingDesc: 'Enter the data to check the reservation',
    testPaperless: 'Test Paperless',
    testPaperlessDesc: 'Enter the data to verify the information of the profiles',
    testPaperlessMultiReservation:
      'A multiple booking has been detected; please perform a new search using the following codes to locate a specific room.',
    testPaperlessRoom: 'Room',
    guestNameNotAvaliable: 'Unnamed',
    guestInformationNoAvaliable: 'No data found for this profile',
    guestLabel: 'Guest',
    holderLabel: 'Holder',
    adultLabel: 'Adult',
    childLabel: 'Child',
    optionsTemplate: {
      option1: 'Download Sample',
      option2: 'Upload File',
    },
    downloadSuccess: 'The file %s is downloaded.',
    downloadError1: 'Error trying downliad the file.xlsx .',
    downloadError2: 'The file.xlsx not exist for this PMS.',
    uploadSuccess: 'The hotel or hotels have been configured correctly.',
    uploadError1: 'Error when attempting to save the configuration or configurations.',
    uploadError2: 'The file name is not valid for this PMS.',
    uploadHotelNotFound: 'The hotelID %s does not belong to this chain.',
    emptyFile: 'The File is empty.',
  },
  states: {
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    pending: 'Pending',
  },
  view: 'View',
  status: 'Status',
  checkinConfig: {
    allowed_since: 'From how many hours before the check-in date is online check-in allowed?',
    allowed_since_desc: 'Leave it to 0 if you do not want to limit it',
    allowed_until: 'How many hours before the check-in date is online check-in allowed?',
    allowed_until_desc: 'Leave it to 0 if you do not want to limit it',
    required_documents: 'For whom is data capture required on a mandatory basis?',
    required_signatures: 'Who has to sign the property contract?',
    required_cardex_signatures: 'Who has to sign the checkin report?',
    capture_docs: 'Document scanner configuration: ',
    success: 'Configuration successfully updated',
    checkinWarning: 'The checkin configuration will be updated',
    chainCheckinWarning: 'The configuration will be updated for all the hotels in the chain.',
    bookingCode: 'Booking code',
    bookingHolder: 'Booking holder',
    entranceDate: 'Checkin date',
    departureDate: 'Departure date',
    nights: 'Nights',
    paperless_start_checkin_timeout_seconds:
      'Maximum display time (in seconds) on the T-Paperless reservation screen',
    paperless_start_checkin_timeout_seconds_desc: 'Leave it to 0 if you do not want to limit it',
    paperless_finalize_checkin_timeout_seconds:
      'Maximum time (in seconds) of display at the end of the reservation in T-Paperless',
    paperless_finalize_checkin_timeout_seconds_desc: 'Leave it to 0 if you do not want to limit it',
    save_cardex: 'Does the checkin report need to be saved?',
    send_cardex: 'For whom does the checkin report need to be sent in the confirmation email?',
    save_contract: 'Does the property contract need to be saved?',
    send_contract: 'For whom does the property contract need to be sent in the confirmation email?',
    paperless_images_slider_timeout:
      'How long (in seconds) will it take for the "T-Paperless rest carousel" to activate after not interacting with the tablet? (WIP)',
    paperless_version: 'What version of Paperless will be used?',
    hardCheckinConfiguration: 'Configuración de Hard Check-in',
    hardCheckinAll: 'Enable hard check-in for all products.',
    hardCheckinPaperless: 'Enable hard check-in only for paperless products.',
    hardCheckinDisabled: 'Disabled,',
    civitfunAdminConfiguration: 'Configuration only available for Civitfun administrators',
    paperless_show_signature_documents:
      'Is it mandatory for the guest to read the legal documents before signing?',
    paperless_auto_next_checkin:
      'Enable automatic advance to the next guest when the check-in of a guest is completed?',
    options: {
      o_v1: 'Current version',
      o_v2: 'New version',
      o_true: 'Yes',
      o_false: 'No',
      o_none: 'None',
      o_adults: 'All adults',
      o_all: 'All guests',
      o_0: 'None',
      o_1: 'One',
      o_1_in_last_process: 'One, in the last process',
      o_holder: 'Holder',
      o_num_adults: 'All adults',
      o_num_guests: 'All guests',
      o_guest_over_2: 'All adults and children over 2 years old',
      o_older_than_10: 'All adults and children over 10 years old',
      o_guest_over_12: 'All adults and children over 12 years old',
      o_guest_over_14: 'All adults and children over 14 years old',
      o_guest_over_16: 'All adults and children over 16 years old',
      o_optional: 'Optional',
      o_required: 'Mandatory',
      o_payment_warranty: 'Payment and warranty',
      o_payment: 'Payment',
      o_warranty: 'Warranty',
      o_1_taxes: 'Taxes',
      o_optional_taxes: 'Optional with fees',
      o_active: 'Yes',
      o_disabled: 'No',
      capture_docs_optional: 'Optional',
      capture_docs_disabled: 'Disabled',
      capture_docs_mandatory: 'Mandatory',
    },
    allOptionsDisabled:
      'At least one of the following options must be enabled: Booking code, Booking holder',
  },
  superUser: {
    selectAccount: 'Select Account',
    changeAccount: 'Change Account',
    accountName: 'Account name',
    hotelName: 'Hotel name',
    email: 'User email',
    access: 'Enter',
  },
  view: 'View',
  status: 'Status',
  communicationChannels: {
    documentsBoxTitle: 'You can customize your e-mails in a very simple way',
    emailsSuccess: 'Email addresses have been updated',
    senderCheckinEmailHeader: 'Sender:',
    emailCheckinHeader: 'Send as cc to:',
    addNewMail: 'Add mail',
  },
  emptyHotelListError:
    'In order to use this functionality you must have a hotel. You can add them from the "Hotels" section',
  user: {
    updateSuccess: 'The user data has been updated correctly.',
    updateError: 'Error updating user data',
    newPassword: 'New password',
    currentPassword: 'Current password',
    emptyFields: 'The fields cannot be empty',
    passwordSuccess: 'The password has been changed',
    sendInvitationWarning: 'An invitation email will be sent to #. Would you like to proceed?',
    sendInviteSuccess: 'An e-mail has been sent to change the password to the new user',
    sendInviteError: 'A user with this e-mail already exists',
    emptyPhone: 'The phone number cannot be empty',
    accountDetailTitle: 'Account Owner',
    changePasswordTitle: 'Change password',
  },
  marketing: {
    slugChangeError:
      'Error changing slug, please try again and if the problem persists contact support',
    slugChangeSuccess: 'Slug changed successfully',
    changeSlugTitle: 'Slug change warning',
    changeSlugWarning:
      'Changing the slug will affect the online check-in links and these will have to be updated manually. Are you sure you want to change it?',
    slugAlreadyExistsError: 'The slug already exists, please choose another one',
    slugValidationError:
      'The slug is not valid, please use lowercase letters, numbers and hyphens (no spaces or special characters)',
    changeSlugDesc:
      'The slug is the part of the URL that identifies the hotel. Changing it will affect the online check-in links and these will have to be updated manually. Use lowercase letters, numbers and hyphens (no spaces or special characters), for example my-new-hotel-slug.',
    hotelSlug: 'Hotel slug',
    chainSlug: 'Chain slug',
    changeSlug: 'Change slug',
    buttonGenerator: 'Web button generator',
    hotelCheckin: 'Hotel Check-In',
    chainCheckin: 'Chain Check-In',
    links: 'Links',
    selectHotel: 'Select an hotel',
    example: 'Example button:',
    buttonText: 'Online Check-in',
    deeplink: 'DEEPLINK: Increase the conversion of your Online Check-ins',
    option: 'Option',
    comingSoon: 'Coming soon',
    deeplink1desc:
      'Use basic parameters in the URL of your guests online Check-in mails to avoid search actions. As soon as your hotel is active, your guests can check-in online without searching for the reservation. You can integrate the link in the pre-stay templates by adding the necessary parameters to perform the search',
    deeplink2desc: 'Use the [BOOKING_IDENTIFIER] to generate a unique link for each booking.',
    bookingCodeTitle: 'What is the BOOKING CODE?',
    bookingCodeDesc: 'It is the locator that your guest received at the time of booking',
    entryDateTitle: 'What is the ENTRANCE DATE?',
    entryDateDesc:
      'The ENTRANCE DATE is the entry date of the booking. Supported formats: DD/MM/YYYY, YYYY/MM/DD, MM-DD-YYYY, YYYY-MM-DD, DD.MM.YYYY',
    bookingIdentifierTitle: 'What is the BOOKING IDENTIFIER?',
    bookingIdentifierDesc:
      'The booking identifier is the unique identifier of a given booking in your PMS. Use it as a dynamic field in your pre-booking mails and increase the conversion of your online check-ins.',
    bookingIdentifierFindTitle: 'Where do I find the BOOKING IDENTIFIER?',
    bookingIdentifierFindDesc:
      'The booking identifier is a field in your PMS. Your CRM should be able to get it from your PMS, in the same way that it gets the name of the reservation holder, the check-in date and other details used in the booking or pre-booking communication.',

    //Booking.com
    deeplinkBooking: 'DEEPLINK: Increase your Online Check-ins conversion with booking.com',
    deeplink1descBooking:
      'Add the provided URL to your internal communications from Booking.com to impact the check-in process of reservations made by guests through the platform',
    bookingCodeTitleBooking: 'Where should I add the BOOKING.COM DEEPLINK?',
    bookingCodeDescBookingLink: 'Follow the detailed instructions in the following article ',
    bookingCodeDescBooking:
      'to configure Booking.com internal communications and add the deeplink.',
    acceptedEntranceDate: 'Select the accepted date format in the deepLink',
    changeEntranceDateSuccess: 'Date changed successfully',
    changeEntranceDateError: 'Error changing the date',
  },
  steps: {
    title: 'Conversion funnel:',
    guestData: 'Guest Form Data',
    surveys: 'Surveys',
    upgrade: 'Upgrade',
    upsell: 'Upsell',
    payments: 'Payment',
    confirmPayment: 'Payment Confirm',
    contracts: 'Contracts + Signature',
    confirm: 'Checkin Confirm',
  },
  quickguide: {
    next: 'Next',
    back: 'Back',
    skip: 'Skip Guide',
    end: 'End Guide',
  },
  registerPaperless: {
    title: 'Account Information',
    createAccount: 'Continue',
    registerOk: 'User registered successfully',
    createButton: 'Add user',
  },
  paymentMethods: {
    emptyTitle: 'Add you payment methods',
    emptyDescription:
      'You can add your credit or debit card or your bank account information (SEPA)',
    addedSuccess: 'Payment method added successfully',
    credit_card: 'Credit card',
    sepa: 'SEPA direct debit',
    expires: 'Expires',
  },
  pmsCategory: {
    pms_api: 'API Configuration',
    pms_hotel_data: 'Hotel data configuration',
    payments: 'Payment configuration',
    address: 'Address configuration',
    checkin: 'Checkin configuration',
    checkout: 'Checkout configuration',
  },
  pmsName: {
    avalon2: 'Antfor (Avalon Channel)',
    avalon: 'Antfor (Civitfun channel)',
    guestportal: 'Quohotel',
    navision: 'Suitech',
    timon: 'Timon Hotel',
    noray_new: 'Noray New',
  },
  pmsFeature: {
    pmsFeatures: 'PMS features:',
    true: '✔️ Yes',
    false: '❌ No',
    attachImages: '🖼️ Images',
    attachCardex: '📄 Files (Cardex)',
    attachContract: '📄 Files (Contract)',
    checkboxLoyalty: '☑️ Checkbox (Loyalty program)',
    checkboxComercial: '☑️ Checkbox (Commercial use of data)',
    checkboxPrivacy: '☑️ Checkboxes (Privacy policy)',
    attachSignature: '✍️ Electronic signature',
    guestPhoto: '🖼️ Guest photo',
  },
  paymentScreen: {
    connectSuccess: 'Connection to the payment gateway has been established successfully',
    connectError: 'Error connecting to the payment gateway',
    defaultSelector: 'Select',
    platform: 'Platform',
  },
  paymentName: {
    stripe: 'Stripe',
    trustpayments: 'Trust Payments',
    mercadopago: 'Mercado Pago',
    redsys: 'Redsys',
    addonpayments: 'Addon Payments',
    sipay: 'Sipay',
    paytef: 'Paytef',
    planet: 'Planet',
    paycomet: 'Paycomet',
    adyen: 'Adyen',
    montevideocomm: 'Montevideocomm',
    transbankwebpay: 'Transbank Webpay',
  },
  doorOpening: {
    add: 'Add door mapping',
    list: 'Door mapping list',
    remove: 'Do you want to delete the selected door opening?',
    roomName: 'Room Name',
    pmsId: 'ID PMS',
    idOpening: 'ID access system',
    import: 'Upload excel',
    downloadTemplate: 'Download sample excel',
    templateFileName: 'Door mapping sample excel',
    defaultSelector: 'Select',
    mantaintenanceTitle: 'Door maintenance',
    mantaintenanceButton: 'Manage',
    platform: 'Platform',
    connectionData: 'Connection data',
    configuration: 'Configuration',
    checkinStatusOptions: {
      indifferent: 'Indifferent',
      checkedIn: 'Done',
    },
    paymentStatusOptions: {
      indifferent: 'Indifferent',
      paid: 'Paid',
    },
    keyType: 'Lockflow',
    keyTypes: {
      app: 'Application',
      pin: 'Pin',
      qr: 'QR Code',
      link: 'Link',
    },
    checkinStatusLabel: 'Check-in state',
    checkinStatusPlaceholder: 'Select check-in state',
    paymentStatusLabel: 'Payment state',
    paymentStatusPlaceholder: 'Select payment state',
    checkinHourLabel: 'Check-in hour',
    checkoutHourLabel: 'Check-out hour',
    missingSuscription: {
      title: 'Get license',
      description:
        "You can set up Door opening for the hotel by activating the 'Door opening' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
  },
  paymentCategory: {
    platform: 'Connection data',
    payment_config: 'Configuration',
    tourist_tax: 'Tourist taxes',
  },
  testOK: 'TEST OK',
  testKO: 'TEST KO',
  accountDetail: {
    functionality: 'Functionality',
    requested: 'Requested',
    active: 'Active',
    activateDeactivate: 'Activate/Deactivate',
    billing: 'Functionalities',
    contract: 'Request',
    available: 'Available',
    activate: 'Activate',
    deactivate: 'Deactivate',
    o_billing: {
      checkin: 'Check-in',
      tpaperless: 'T-Paperless',
      paperless_push: 'Paperless Push',
      upgrade: 'Upselling (Legacy)',
      upsell_module: 'Upselling 🆕',
      upsell: 'Cross-Selling (Legacy)',
      'cross-sell_module': 'Cross-Selling 🆕',
      payment: 'Payment Protection',
      door_opening: 'Door Opening',
      communication_tool: 'Guestlink',
      police_report: 'Guest Registration',
      checkout: 'Check-out',
      pms: 'PMS integration',
      booking: 'Booking.com channel',
      roomAssignment: 'Room assignment',
      softCheckout: 'Soft checkout',
      kiosk: 'Auto Check-in',
      mts: 'MTS channel',
      hbx: 'HBX channel',
      civitfun_sftp: 'SFTP Civitfun',
      checkin_sftp: 'Check-in Documents SFTP',
      hbx_hcn: 'HCN',
      hbx_invoicing: 'Invoice Automation',
    },
    emailWarningTitle: 'Hire the functionality',
    emailWarning:
      'The request will be notified and handled as soon as possible by our Customer Success team.',
    emailSuccess:
      'We have received your request correctly. We will contact you as soon as possible.',
    dashboardWarning:
      'Our Customer Success team has been informed of your request and will contact you shortly. By clicking "OK" you will be redirected to the settings screen of the selected functionality for configuration and activation.',
  },
  mailTemplates: {
    adviceChangesTitle: '⚠️ Advice for template changes',
    adviceChanges: 'Changes will be made to these fields:',
    adviceChangesList1: '- Send from\n- Recipient\n- CC List\n- BCC List',
    adviceChangesList2:
      '- Template name\n- Email type\n- Template type\n- Scheduling\n- Language\n- Subject\n- Mail Template',
    adviceChangesAll: 'BE CAREFUL: You have active to apply the changes to all hotels',
    senderRecipients: 'Sender and Recipients',
    configTemplate: 'Template Configuration',
    template: 'Mail Template',
    enabled: 'Active',
    type: 'Template type',
    templateName: 'Template name',
    subject: 'Subject',
    scheduling: 'Scheduling',
    createTemplate: 'Create template',
    matchingTypeWarningTitle: 'There is already an active template of this type',
    matchingTypeWarning:
      'Only one template can be active for each template type. Do you still want to activate the selected one?',
    emailType: 'Email type',
    marketing: 'Marketing',
    transactional: 'Transactional',
    templateType: {
      ['pre-stay']: 'Pre-stay',
      ['intra-stay']: 'Intra-stay',
      ['post-stay']: 'Post-stay',

      ['pre-stay-checkin-partial']: 'Check-in partial (each guest)',
      ['pre-stay-checkin-final']: 'Check-in finalized (just holder)',
      ['pre-stay-before-entrance-24-hour']: '24h before entrance date',
      ['pre-stay-before-entrance-48-hour']: '48h before entrance date',
      ['pre-stay-before-entrance-72-hour']: '72h before entrance date',
      ['pre-stay-before-entrance-5-day']: '5 days before entrance date',
      ['pre-stay-before-entrance-1-week']: '1 week before entrance date',
      ['pre-stay-before-entrance-2-week']: '2 weeks before entrance date',
      ['pre-stay-before-entrance-30-day']: '30 days before entrance date',
      ['pre-stay-police-report-notify-report-error']: 'Police report summary',

      ['intra-stay-checkout-partial']: 'Check-out partial (each guest)',
      ['intra-stay-checkout-final']: 'Check-out finalized',
      ['intra-stay-on-entrance-0-hour']: 'On entrance date',
      ['intra-stay-after-entrance-24-hour']: '24h after entrance date',
      ['intra-stay-before-departure-24-hour']: '24h before departure date',
      ['intra-stay-on-departure-0-hour']: 'On departure date',

      ['post-stay-after-departure-24-hour']: '24h after departure date',
      ['post-stay-after-departure-48-hour']: '48h after departure date',
      ['post-stay-after-departure-72-hour']: '72h after departure date',

      ['pre-stay-payment-partial']: 'Payment confirmation',
      ['pre-stay-payment-before-entrance-48-hour']: 'Payment 48h before check-in date',

      ['pre-stay-door-opening-on-checkin']: 'Email for key generation upon completing check-in',
      ['pre-stay-door-opening-0-hour']: 'Email for key generation on the day of arrival',

      ['pre-stay-upsell-24-hour']: 'Upselling 24h before entrance date',
      ['pre-stay-upsell-48-hour']: 'Upselling 48h before entrance date',
      ['pre-stay-upsell-hotel-requested']: 'Upselling request for Hotelier',
      ['pre-stay-upsell-hotel-accepted']: 'Upselling confirmation for Hotelier',
      ['pre-stay-upsell-hotel-rejected']: 'Upselling rejection for Hotelier',
      ['pre-stay-upsell-guest-accepted']: 'Upselling confirmation for Guest',
      ['pre-stay-upsell-guest-rejected']: 'Upselling rejection for Guest',

      ['pre-stay-cross-sell-24-hour']: 'Cross-sell 24h before entrance date',
      ['pre-stay-cross-sell-48-hour']: 'Cross-sell 48h before entrance date',
      ['pre-stay-cross-sell-hotel-requested']: 'Cross-sell request for Hotelier',
      ['pre-stay-cross-sell-hotel-accepted']: 'Cross-sell confirmation for Hotelier',
      ['pre-stay-cross-sell-hotel-rejected']: 'Cross-sell rejection for Hotelier',
      ['pre-stay-cross-sell-guest-accepted']: 'Cross-sell confirmation for Guest',
      ['pre-stay-cross-sell-guest-rejected']: 'Cross-sell rejection for Guest',
    },
    suscriptionDisabledTitle: 'Get a Guestlink license',
    suscriptionDisabled:
      'You can enable the pre-stay guest communication activating the Guestlink license. Click the button bellow and the Customer Success team will get in touch with you',
    suscriptionCTA: 'Contact me about Guestlink',
    suscriptionRequestedTitle: 'Functionality pending activation',
    suscriptionRequested:
      'You have already made the request to activate the functionality. Our Customer Success team has been informed of your request and will contact you shortly.',
    errorSetState: 'An error occurred while updating the template status',
    successSetState: 'The status of the template has been updated',
    sendFrom: 'Send from',
    ccList: 'CC List',
    bccList: 'BCC List',
    recipient: 'Recipient',
    language: 'Language',
    autofillLanguages: 'Autofill all languages',
    back: 'Back',
    errorSendFrom: 'Sender address is invalid',
    errorCCList:
      'Mailing list validation error in CC. Addresses must be valid and separated by commas.',
    errorBCCList:
      'Mailing list validation error in BCC. Addresses must be valid and separated by commas.',
    addAttachment: 'Add attachment',
    testButton: 'Send test mail',
    testMailDesc:
      'Enter the address where you want to send the test email (you can send more than one separating the emails by commas)',
    sendButton: 'Send',
    errorTestEmailValidation: 'The sender address is invalid',
    errorTestEmail: 'Error sending test mail',
    successTestEmail: 'Test mail has been sent',
    invalidSize: 'The file exceeds the maximum allowed file size of ',
    invalidFormat: 'File extension not allowed',
    saveSuccess: 'Template changes have been saved',
    requestGuestlinkSuccess:
      'Our Customer Success team has been informed of your request and will contact you shortly.',
    saveError: 'Data could not be saved',
    emailListHint: 'Insert emails separated by commas',
    sendFromHint: 'Mailing address',
    createSuccess: 'Template created successfully',
    createError: 'Error while creating the template',
    deleteGuestlinkItemTitle: 'Are you sure you want to delete the template?',
    deleteGuestlinkItemDescription: 'The template for the selected hotel will be deleted',
    deleteGuestlinkItemCTA: 'Delete template',
    nameError: 'You must enter a valid name for the template',
    scheduleError:
      'It is not possible to change to the requested template type without an active Guestlink license.',
    saveErrorSameTypeTitle: 'There is an active template of the same type',
    saveErrorSameTypeInfo:
      'It is not possible to change to the requested template type as there is currently an active template of the same type and schedule',
    scheduleEmptyError: 'You must select a schedule for the template',
  },
  tagInserter: {
    hint: 'Select a tag for the template',
    button: 'Insert',
    subjectHint: 'Select a tag for the subject',
    nameTagHint: 'Select a tag',
    documentAddon: '.pdf',
  },
  paymentList: {
    locatorCol: 'Payment locator',
    bookingLocator: 'Booking locator',
    purchaseState: 'Payment state',
    dateCol: 'Date',
    tokenCol: 'Payment token',
    amountCol: 'Amount',
  },
  paperlessPush: {
    title: 'Push Configuration',
    pmsId: 'PMS ID',
    ipWhitelist: "Allowed IP's",
    apiKey: 'API Key',
    pmsIdHint: 'Insert the hotel ID in the PMS',
    ipWhitelistHint: 'Insert IP addresses separated by commas',
    example: 'Link Example',
    errorWhitelist: 'Error validating IP addresses',
    disabledSuscription:
      "This hotel doesn't have paperless push enabled. You can activate it from the 'Account Details' screen in the 'Functionality' section.",
    activateSuscription: 'Activate Functionality',
    updateSuccess: 'Configuration updated successfully',
    updateError: 'Error updating paperless push configuration',
    deleteSuccess: 'Device deleted successfully',
    deleteError: 'Error deleting the device',
    devicesTitle: 'Registered devices',
    selectDevice: 'Select a device',
    selectDevicesEmpty: 'No devices registered',
    deleteDeviceWarningTitle: 'Delete device',
    deleteDeviceWarningDescription:
      'Are you sure you want to delete this device? All data will be permanently deleted and cannot be recovered.',
    editDeviceModal: {
      editTitle: 'Edit Device',
      editDescription: 'You can change the device name that will be shown when using it.',
      editNote:
        'After saving the new configuration, you may need to restart the session on the device.',
      editInputName: 'New name to assign to the device',
      saveButton: 'Save changes',
      errors: {
        deviceNotFound: 'Device not found.',
        nameAlreadyInUse: 'The name is already in use. Please choose a different one.',
        generalError: 'Error saving the configuration.',
        emptyName: 'The new name cannot be empty.',
      },
      successUpdate: 'Device updated successfully.',
    },
    activeApiPaperlessTitle: 'Activate Push API',
    credentials: 'Credentials',
    activateText: 'Activate',
    activatedText: 'Activated',
  },
  dynamicForms: {
    group: {
      document_data: 'Document data',
      contact_data: 'Personal data',
      other: 'Fields',
      uploadDocument: 'Aditional documents',
    },
    guestType: {
      holder_1: 'Domestic Holder',
      holder_0: 'Non-domestic Holder',
      adult_1: 'Domestic Adult',
      adult_0: 'Non-domestic Adult',
      child_1: 'Domestic Child',
      child_0: 'Non-domestic Child',
    },
    visible: 'Visible',
    required: 'Mandatory',
    field: 'Field',
    selectField: 'Field determining whether a guest is domestic or non-domestic',
    fields: {
      documentCountry: 'Document country',
      residenceCountry: 'Residence country',
      birthCountry: 'Birth country',
      documentIssuanceCountry: 'Document Issuance Country',
      nationality: 'Nationality',
    },
  },
  requestSuscription: {
    requestSent:
      'We have received the request successfully. We will get in touch with you as soon as possible.',
    send: 'Send request',
  },
  payment: {
    missingSuscription: {
      title: 'Get license',
      description:
        "You can set up Payment protection for the hotel by activating the 'Payment protection' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
  },
  policeReport: {
    extension: 'Extension',
    completeFileName: 'Full file name',
    retrySendingMessage:
      'For "Error on target platform" messages try launching that report again within each record',
    retrySendingFileNotFound:
      'If the file was not found, check that it is in the SFTP and try forcing the sending again.',
    warningSFTPSendError:
      'An error was detected in the export file configuration. Please check the configuration.',
    retrySendingPMS:
      'If there was an error retrieving bookings from the PMS system, try forcing the sending again.',
    captionError: 'Error detected',
    captionOk: 'Processed correctly',
    captionPending: 'Sent and pending SES',
    dateCol: 'Check-in date',
    statusCol: 'Status / Error',
    hotelCol: 'Property Name',
    contractCol: 'Contract number',
    contractTypeCol: 'Request type',
    guestNameCol: 'Guest name',
    guestSurnameCol: 'Guest surname',
    secondSurnameCol: 'Second surname',
    batchCol: 'Batch',
    actionCol: 'Action',
    contractData: 'Contract data',
    captionCancelledOk: 'Cancelled correctly',
    paymentData: 'Payment data',
    guestData: 'Guest data',
    addressData: 'Address data',
    sendData: 'Save and send',
    showSendWarningTitle: 'Send',
    showSendWarning: 'The data will be sent permanently. Do you want to continue?',
    mandatoryFieldsError: 'You must fill in all the form fields',
    emailError: 'The email address format is incorrect',
    download: 'Download SES file',
    downloadSuccess: 'The download of the files has been initiated',
    errorOnTargetPlatform: 'Error on target platform',
    downloadError: 'Error downloading the files',
    noReportsErrorInFileValidation:
      'Your file contains errors that do not allow the reports to be analyzed',
    back: 'Back',
    fileNotFound: 'The file was not found in SFTP for the indicated date',
    sftpConfig: 'FILE EXPORT',
    apiConfig: 'PMS INTERFACE',
    s3Config: 'SFTP CIVITFUN',
    noStatus: 'Not specified',
    sftpWarning: 'WARNING! You are using configuration via "File export".',
    sftpWarningDesc:
      'You can change your "File export" connection to "PMS interface" configuration by clicking on the "Save" button.',
    apiConfigGood: 'The "PMS interface" configuration is active',
    apiGoodConfigDesc:
      'By using the "PMS interface" configuration, daily reports will be retrieved through your currently used PMS system.',
    whoDoIReportTo: 'Who do I report to?',
    connectionType: 'Data source type',
    chooseConnectionType: 'Data source',
    ftpHost: 'URL',
    sftpConfigurationTitle: 'File export configuration',
    s3ConfigurationTitle: 'Civitfun SFTP configuration',
    ftpUser: 'User',
    ftpPass: 'Password',
    ftpPort: 'Port',
    ftpFilePrefix: 'Prefix',
    ftpFileSufix: 'Sufix',
    fileFormat: 'Format',
    ftpDirPath: 'File directory',
    ftpFiles: 'Directory file list',
    ftpFileContent: 'File content',
    explainRedColorFileValidation: 'If any line is {red}, no record of that file will be processed',
    ftpResult: 'File export validation result',
    validateFileExport: 'Validate',
    validateSFTPWithoutErrors: 'File validated, it does not cotains any error',
    testFile: 'File to validate',
    validateFileExportSuccess: 'Validation finished successfully',
    saveConfigSuccess: 'Configuration has been saved successfully',
    saveConfigError: 'Configuration could not be saved correctly',
    validateFileExportError: 'Validation failed',
    noFilesFound: 'No files have been found',
    ftpSuccess: 'SFTP configuration has been saved successfully',
    ftpError: 'SFTP configuration could not be saved correctly',
    save: 'Save',
    sesConfig: 'SES Configuration',
    sesUser: 'User',
    sesPass: 'Password',
    ertzPass: 'Certificate password',
    lessorCode: 'Lessor code',
    establishmentCode: 'Establishment code',
    uploadPfx: 'Upload your file here',
    deleteFile: 'Are you sure you want to delete the file?',
    delete: 'Delete file',
    sesSuccess: 'SES configuration has been saved successfully',
    sesError: 'The configuration could not be saved correctly',
    ertzError: 'The configuration could not be saved correctly',
    ertzDeleteFileSuccess: 'The file has been deleted successfully',
    ertzDeleteFileError: 'An error occurred deleting the file',
    ertzFileError: 'The file could not be saved correctly',
    checkConnection: 'Check connection',
    checkConnectionSuccess: 'Connection to the SFTP server has been established successfully',
    checkConnectionError: 'Error connecting to the SFTP server',
    checkSESConnectionSuccess: 'Connection to SES has been established successfully',
    checkERTZConnectionSuccess: 'Connection to Ertzaintza has been established successfully',
    missingFields: 'There are missing fields to complete',
    ertzSuccess: 'Ertzaintza configuration has been saved successfully',
    ertzFileSuccess: 'The file has been saved successfully',
    checkSESConnectionError: 'Error connecting to SES',
    checkERTZConnectionError: 'Error connecting to Ertzaintza',
    forceDownloadTrigger: 'Force submission',
    forcedDownloadTrigger: 'Forced submission',
    downloadAllFilesButton: 'Download all submissions',
    forceDownloadTriggerInfo: 'The request to send guest data to SES has been triggered',
    forceDownloadTriggerWarning: 'You cannot force the shipment if there are records for this day',
    forceDownloadTriggerError: 'Error sending the request',
    erronInTheReport: 'Error in a guest in the reservation or in the contract',
    sendAllErrorsButton: 'Resend all errors',
    sendAllErrorsSuccess: 'All errors have been sent for the selected day',
    sendAllErrorsError: 'Error sending all errors',
    sendDefaultAltaStatus: 'Send with "Alta" delivery type by default for all communications',
    getStatusFromFile: 'Get the delivery type from the export file',
    defaultAltaStatusTitle: 'Configure how the delivery type should be handled.',
    cancelledNotReportedMessage:
      'Only bookings previously reported in Civitfun can be processed. Bookings not reported must be submitted directly through the official authority platform.',
    missingSuscription: {
      title: 'Get a police report license',
      description:
        "You can set up the police report for the hotel by activating the 'Police Report Module' license. Click the button below, and the Customer Success team will get in touch with you.",
      requestSent:
        'We have received the request successfully. We will get in touch with you as soon as possible.',
      send: 'Send request',
    },
    edit: {
      error: 'An error occurred while sending the data',
      success: 'The data has been sent successfully',
    },
    status: {
      ok: 'Processed correctly',
      error: 'Error',
      pending: 'Sent and pending SES',
    },
    delete: {
      error: 'An error occurred while deleting the data.',
      success: 'The data was deleted successfully.',
    },
    detailFields: {
      reference: 'Contract / reservation reference',
      date: 'Contract date',
      contractDate: 'Contract date',
      entrance: 'Check-in date',
      departure: 'Check-out date',
      guests: 'Number of guests',
      numGuests: 'Number of guests',
      paymentType: 'Payment type',
      role: 'Role',
      roleType: 'Role',
      name: 'Name',
      surname: 'First name',
      secondSurname: 'Second surname',
      contactType: 'Contact data type',
      contact: 'Contact',
      contactValue: 'Contact',
      documentType: 'Document type',
      documentNumber: 'Document number',
      reservationType: 'Request type',
      supportDocument: 'Document support number',
      country: 'Country',
      address: 'Address',
      municipality: 'Municipality',
      municipalityName: 'Municipality name',
      municipalityCode: 'Municipality code',
      zipCode: 'Zip code',
      documentSupport: 'Document support number',
      familyRelationship: 'Family relationship',
      relationship: 'Family relationship',
      birthDate: 'Birth date',
      childrenCount: 'Number of children',
      requiredFields: 'Required field is missing:',
      fieldValidation: 'Field validation error:',
      nationality: 'Nationality',
      gender: 'Genre',
      genders: {
        male: 'Male',
        female: 'Female',
        other: 'Other',
      },
    },
    error: {
      zipCode:
        'The postal code format is not correct or it does not belong to the selected municipality',
      documentNumber: 'The document number format is incorrect or the length is too long (15 max.)',
      emailError: 'The email address format is not correct',
      birthDate: 'The birth date is not correct',
      documentSupport: 'The support number format is not correct',
      documentRequired: 'Document type and document number are required.',
      familyRelationship: 'You must enter a valid family relationship',
      contactError:
        'The contact field format is incorrect: The format is incorrect or the length of the field is too long (60 max. for email. 20 max. for phone)',
      documentDuplicated: 'There cannot be more than one guest with the same document number',
      invalidContactValue: 'Invalid contact value:  ',
      contactType: 'If a contact type is selected, the value cannot be empty',
      address: 'The address cannot contain the characters: [ < > & " \' ]',
    },
    paymentType: {
      EFECT: 'Cash',
      TARJT: 'Credit card',
      TRANS: 'Transaction',
      PLATF: 'Payment platform',
      MOVIL: 'Mobile payment',
      TREG: 'Gift card',
      DESTI: 'Payment at destination',
      OTRO: 'Other payment methods',
    },
    reservationType: {
      A: 'Reservation',
      B: 'Cancellation',
      null: 'Not specified',
    },
    role: {
      TI: 'Contract holder',
      VI: 'Traveler',
    },
    contactType: {
      telefono: 'Mobile / Landline',
      email: 'Email',
    },
    contactTypeRH: {
      telefono: 'Mobile / Landline',
      email: 'Email',
      empty: 'Reset',
    },
    documentType: {
      passport: 'PASSPORT',
      dni: 'DNI',
      idCard: 'ID CARD',
      residencePermit: 'RESIDENT PERMIT',
      drivingLicence: 'DRIVING LICENCE',
      other: 'OTHER',
      empty: 'Reset',
    },
    sideItem: {
      send: 'Send',
      booking: {
        title: 'Request type',
        header: 'Check-ins',
        desc: 'The number of guests who have checked-in',
      },
      checkin: {
        title: 'Police Report',
        header: 'Sent to the Police',
        desc: 'Number of online check-ins sent to the police',
      },
      send: {
        header: 'Send data manually',
        desc: 'You can manually send this information to SES after editing the missing fields',
      },
      delete: {
        warning: {
          title: 'Delete',
          description:
            'All data will be permanently deleted and cannot be recovered. Are you sure?',
        },
        button: 'Delete',
        title: 'Delete the reservation',
        desc: 'Delete the reservation and all guests from the system',
      },
    },
    dateSelector: {
      title: 'Select one of the following options:',
      yesterday: 'The date in the file name corresponds to the check-in date of the reservations.',
      today:
        'The date in the file name corresponds to the day after the check-in date of the reservations.',
    },
    statusTable: {
      status: {
        loading: 'Loading',
        error: 'Error',
        ok: 'OK',
        notSent: 'Not sent',
      },
      send: 'Send status',
      platform: 'Platform',
      interfacePlatform: 'Booking Search Interface',
      platformConnection: 'Platform connection status',
      searchBookingStatus: 'Booking search status',
      searchFileTimestamp: 'Time when the file was searched',
      fileNotFound: 'File not found',
      reservationRetrievalStatus: 'Reservation retrieval status',
    },
    ses: {
      ses: 'SES HOSPEDAJES',
      caption: {
        captionError: 'Error detected',
        captionOk: 'Processed / cancelled correctly',
        captionPending: 'Sent and pending SES',
      },
      status: {
        ok: 'Processed correctly',
        error: 'Error',
        pending: 'Sent and pending SES',
      },
    },
    ertz: {
      ertz: 'ERTZAINTZA',
      caption: {
        captionError: 'Error detected',
        captionOk: 'Processed / cancelled correctly',
        captionPending: 'Processed on Civitfun',
      },
      status: {
        ok: 'Processed correctly',
        error: 'Error',
        pending: 'Processed on Civitfun',
      },
    },
    mossos: {
      warnings: {
        errorSaving: 'The configuration could not be saved correctly',
        successSaving: "MOSSOS D'ESQUADRA configuration has been saved successfully",
      },
      mossos: `MOSSOS D'ESQUADRA`,
      caption: {
        captionError: 'Error detected',
        captionOk: 'Processed / cancelled correctly',
        captionPending: 'Processed on Civitfun',
      },
      status: {
        ok: 'Processed correctly',
        error: 'Error',
        pending: 'Processed on Civitfun',
      },
    },
    missingSubscription: {
      title: 'Get License',
      description:
        "You can set up the reservation report for the hotel by activating the 'reservation report' license. Click the button below and the Customer Success team will contact you",
    },
    sesPostalCodeError:
      '⚠️ Important: SES Hospedajes has stopped accepting Postal Codes without an associated district. Please make sure that all postal codes in your records correspond to recognized districts. Otherwise, you will need to correct them before submitting.',
  },
  missingSuscription: {
    title: 'Get $1 license',
    description:
      "You can set up $1 for the hotel by activating the '$1 Module' license. Click the button below, and the Customer Success team will get in touch with you.",
    requestSent:
      'We have received the request successfully. We will get in touch with you as soon as possible.',
    send: 'Send request',
  },
  upsell,
  guestlink: {
    host: 'SMTP host',
    hostPlaceholder: 'Enter the SMTP server URL example.domain.com',
    port: 'Port',
    securityLayer: 'Encryption',
    smtpAuth: 'SMTP Authentication',
    user: 'User',
    userPlaceholder: 'SMTP user',
    password: 'Password',
    passwordPlaceholder: 'SMTP password',
    defaultSender: 'Default sender',
    defaultSenderPlaceholder: 'Enter your email example@email.com',
    enabled: 'Enabled',
    disabled: 'Disabled',
    save: 'Save',
    deleteConfig: 'Delete Configuration',
    cancel: 'Cancel',
    sendTestEmail: 'Send test mail',
    adviceSaveSmtpConfig: '⚠️ Advice SMTP Configuration',
    adviceDeleteSmtpConfig:
      'Disabling it will delete your previous SMTP settings. It cannot be recovered',
    adviceDeleteAllSmtpConfig: 'BE CAREFUL: You have active to apply the changes to all hotels',
    checkConnection: 'Check connection',
    smtpSuccess: 'SMTP configuration has been saved successfully',
    smtpError: 'SMTP configuration could not be saved correctly',
    checkConnectionSuccess: 'Connection to the SMTP server has been established successfully',
    checkConnectionError: 'Error connecting to the SMTP server',
    testEmailSuccess: 'Test email has been sent successfully',
    testEmailError: 'Error sending test email',
    requiredFieldsError: 'You must fill in all the form fields',
    smtpNotConfigured: 'Should save SMTP configuration',
    missingSuscription: {
      title: 'Get license',
      description:
        "You can set up Guestlink for the hotel by activating the 'Guestlink' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
    selectIntegrationType: 'Select integration type',
    integrationTypeOthers: 'Others',
    gmailConnect: 'Connect to Gmail',
    gmailDisconnect: 'Disconnect',
    gmailConnected: 'Connected',
    gmailDisconnected: 'Disconnected',
    gmailConnectError: 'Error connecting to Gmail',
    gmailDisconnectError: 'Error disconnecting from Gmail',
    gmailDisconnectSuccess: 'Disconnected from Gmail',
    gmailConnectSuccess: 'Connected to Gmail',
    gmailDisconnectConfirm: 'Are you sure you want to disconnect from Gmail?',
    disabledSMTPAuth: 'Disabled, this email will be used: noreply@civitfun.com',
    enabledSMTPAuth: 'Enabled, the Email configured in User will be used',
  },
  billingConfig: {
    billingInfo: {
      title: 'Billing information',
      companyLegalName: 'Company legal name',
      companyCommercialName: 'Company commercial name',
      companyCountryCode: 'Company country',
      billingAddress: 'Billing address',
      billingMunicipality: 'Billing municipality',
      billingProvince: 'Billing province',
      taxIdentificationNumber: 'Tax identification number',
      billingContactName: 'Billing contact name',
      billingContactEmail: 'Billing contact email',
      billingPhoneNumber: 'Billing phone number',
      companyLegalName_hint: 'Company legal name',
      companyCommercialName_hint: 'Company commercial name',
      companyCountryCode_hint: 'Company country',
      billingAddress_hint: 'Address, zip/postal code',
      billingMunicipality_hint: 'Municipality',
      billingProvince_hint: 'Province',
      taxIdentificationNumber_hint: 'Tax identification number',
      billingContactName_hint: 'Name Surname',
      billingContactEmail_hint: 'mail@email.com',
      billingPhoneNumber_hint: '+34 666888999',
      saveButton: 'Save',
      editButton: 'Edit',
      cancelButton: 'Cancel',
      saveMessageOK: 'Billing information has been changed successfully',
      invalidEmailError: 'The email address is not valid',
      formHasErrors: 'The form has empty or invalid fields',
    },
    billingStatus: {
      title: {
        OK: 'Billing information completed',
        KO: 'Complete billing information',
      },
      text: {
        OK: 'Thank you for providing the necessary billing information. Your details have been successfully added. Once a new invoice needs to be generated, your information will be included, and the invoice will be promptly sent to the designated contact.',
        KO: 'To ensure accuracy in our invoices and proper delivery to the designated contact, please provide the necessary billing information.',
      },
    },
    billingContract: {
      title: 'Contract management',
      active: 'Active',
      inactive: 'Inactive',
      uploadButton: 'Billing Upload',
      modal: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        title: 'Select category',
        subtitle: 'Select the category you want to create',
        title_contract: 'Contract',
        title_invoice: 'Invoice',
        title_license: 'Licence',
        option: {
          contract: 'Contract',
          license: 'Licence',
          invoice: 'Invoice',
        },
        contract: {
          save: 'Save',
          delete: 'Delete',
        },
      },
      table: {
        id: 'Contract ID',
        name: 'Contract name',
        signatureDate: 'Date of signature',
        status: 'Status',
        actions: 'Actions',
        empty_contract: 'You do not have any contract',
        contact_support: 'Please, contact our support team',
      },
      uploadContract: 'Upload contract',
      contractName: 'Contract name',
      contractName_hint: 'Enter the name of the contract',
      signatureDate: 'Signature date',
      signatureDate_hint: 'dd/mm/YYYY',
      orderNumber: 'Order number',
      orderNumber_hint: 'ORD-123456Z',
      fileUpload: {
        title: 'Select a file',
        hint: 'JPG, PNG or PDF, file size no more than 10MB',
        invalid: 'The file is not valid',
        OK: 'File uploaded successfully',
        KO: 'Upload failed, please try again',
      },
      saveContractMessageOK: 'The contract has been successfully created',
      formHasErrors: 'The form contains empty or incorrect fields',
      deleteHotelContractMessageOK: 'The contract has been successfully deleted',
      editContractMessageOK: 'The contract has been successfully updated',
    },
    licence: {
      title: 'Licence management',
      inactive: 'Inactive',
      active: 'Active',
      deleteHotelLicenceMessageOK: 'The licence has been successfully deleted',
      editLicenceMessageOK: 'The licence has been successfully updated',
      saveLicenceMessageOK: 'The licence has been successfully created',
      table: {
        id: 'Licence ID',
        name: 'Licence',
        contractId: 'Contract ID',
        hotelName: 'Hotel name',
        type: 'Type',
        type_annual: 'Annual',
        type_monthly: 'Monthly',
        type_bimonthly: 'Bimonthly',
        type_quarterly: 'Quarterly',
        type_four_monthly: 'Four monthly',
        type_biannual: 'Biannual',
        type_two_yearly: 'Two yearly',
        type_oneshot: 'One Shot',
        startDate: 'Start date',
        renewalDate: 'Renewal date',
        endDate: 'End date',
        status: 'Status',
        price: 'Price',
        actions: 'Actions',
        empty_licence: 'You do not have any licence',
        contact_support: 'Please, contact our support team',
      },
      modal: {
        title: 'Licence',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
      },
      types: {
        setup: 'Set Up',
        integration_cost: 'Integration Cost',
        checkin: 'Check-in',
        upselling: 'Upselling',
        crossselling: 'Cross-Selling',
        payment_protection: 'Payment Protection',
        door_opening: 'Door Opening',
        guestlink: 'Guestlink',
        guest_registration: 'Guest Registration',
        checkout: 'Check-out',
        push: 'Push Paperless',
        paperless: 'T-Paperless',
        ftp: 'FTP',
        multitablet_option: 'Multitablet',
        grs: 'Group Reservation System',
        booking_engine: 'Booking Engine',
        hcn: 'Hotel Confirmation Number',
        document_scanner: 'Document Scanner',
        facial_recognition: 'Facial recognition',
        invoice_automation: 'Invoice Automation',
        online_checkin_aggregator: 'Online Check-in Aggregator',
        automated_booking_loading: 'Automated Booking Loading',
      },
      form: {
        licence: 'Licence',
        licence_hint: 'Select the licence to create',
        contract: 'Contract',
        contract_hint: 'Contract associated',
        start_date: 'Start date',
        start_date_hint: 'dd-mm-yyyy',
        price: 'Price',
        price_hint: 'Add price',
        periodity: 'Periodity',
        periodity_hint: 'Select periodity',
        currency_hint: '-',
        currency_eur: '€',
        currency_usd: '$',
        invalidLicenceError: 'Empty field or licence repeated in another contract',
      },
    },
    invoice: {
      title: 'Invoice Management',
      pending: 'Pending',
      paid: 'Paid',
      overdue: 'Overdue',
      saveInvoiceMessageOK: 'The invoice has been successfully created',
      formHasErrors: 'The form contains empty or incorrect fields',
      deleteHotelInvoiceMessageOK: 'The invoice has been successfully deleted',
      editInvoiceMessageOK: 'The invoice has been successfully updated',
      form: {
        uploadInvoice: 'Upload invoice',
        invoiceId: 'Invoice ID',
        invoiceId_hint: 'Enter the invoice ID',
        invoiceInternalId: 'Holded ID',
        invoiceInternalId_hint: 'Enter the holded invoice ID',
        date: 'Invoice date',
        date_hint: 'dd-mm-yyyy',
        contractId: 'Contract',
        contractId_hint: 'Contract associated',
        amount: 'Amount',
        amount_hint: 'Add amount',
        currency_hint: '-',
        currency_eur: '€',
        currency_usd: '$',
        status: 'Invoice status',
        status_hint: 'Actual invoice status',
        invalidInvoiceIdError: 'The field is empty or another invoice exists with the same ID',
        invalidInvoiceInternalIdError:
          'The field is empty or another invoice exists with the same ID',
      },
      table: {
        id: 'Invoice ID',
        date: 'Invoice date',
        contractId: 'Contract ID',
        hotelName: 'Hotel name',
        status: 'Status',
        amount: 'Amount',
        actions: 'Actions',
        empty_invoice: 'You do not have any invoices yet',
        invoice_status_pending: 'Pending',
        invoice_status_paid: 'Paid',
        invoice_status_overdue: 'Overdue',
      },
      modal: {
        title: 'Invoice',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
      },
      fileUpload: {
        title: 'Select a file',
        hint: 'JPG, PNG or PDF, file size no more than 10MB',
        invalid: 'The file is not valid',
        OK: 'File uploaded successfully',
        KO: 'Upload failed, please try again',
      },
    },
    countryCodes: {
      CODE_AF: 'Afghanistan',
      CODE_AX: 'Åland Islands',
      CODE_AL: 'Albania',
      CODE_DZ: 'Algeria',
      CODE_AS: 'American Samoa',
      CODE_AD: 'Andorra',
      CODE_AO: 'Angola',
      CODE_AI: 'Anguilla',
      CODE_AQ: 'Antarctica',
      CODE_AG: 'Antigua and Barbuda',
      CODE_AR: 'Argentina',
      CODE_AM: 'Armenia',
      CODE_AW: 'Aruba',
      CODE_AU: 'Australia',
      CODE_AT: 'Austria',
      CODE_AZ: 'Azerbaijan',
      CODE_BS: 'Bahamas',
      CODE_BH: 'Bahrain',
      CODE_BD: 'Bangladesh',
      CODE_BB: 'Barbados',
      CODE_BY: 'Belarus',
      CODE_BE: 'Belgium',
      CODE_BZ: 'Belize',
      CODE_BJ: 'Benin',
      CODE_BM: 'Bermuda',
      CODE_BT: 'Bhutan',
      CODE_BO: 'Bolivia, Plurinational State of',
      CODE_BQ: 'Bonaire, Sint Eustatius and Saba',
      CODE_BA: 'Bosnia and Herzegovina',
      CODE_BW: 'Botswana',
      CODE_BV: 'Bouvet Island',
      CODE_BR: 'Brazil',
      CODE_IO: 'British Indian Ocean Territory',
      CODE_BN: 'Brunei Darussalam',
      CODE_BG: 'Bulgaria',
      CODE_BF: 'Burkina Faso',
      CODE_BI: 'Burundi',
      CODE_KH: 'Cambodia',
      CODE_CM: 'Cameroon',
      CODE_CA: 'Canada',
      CODE_CV: 'Cape Verde',
      CODE_KY: 'Cayman Islands',
      CODE_CF: 'Central African Republic',
      CODE_TD: 'Chad',
      CODE_CL: 'Chile',
      CODE_CN: 'China',
      CODE_CX: 'Christmas Island',
      CODE_CC: 'Cocos (Keeling) Islands',
      CODE_CO: 'Colombia',
      CODE_KM: 'Comoros',
      CODE_CG: 'Congo',
      CODE_CD: 'Congo, the Democratic Republic of the',
      CODE_CK: 'Cook Islands',
      CODE_CR: 'Costa Rica',
      CODE_CI: 'Côte dIvoire',
      CODE_HR: 'Croatia',
      CODE_CU: 'Cuba',
      CODE_CW: 'Curaçao',
      CODE_CY: 'Cyprus',
      CODE_CZ: 'Czech Republic',
      CODE_DK: 'Denmark',
      CODE_DJ: 'Djibouti',
      CODE_DM: 'Dominica',
      CODE_DO: 'Dominican Republic',
      CODE_EC: 'Ecuador',
      CODE_EG: 'Egypt',
      CODE_SV: 'El Salvador',
      CODE_GQ: 'Equatorial Guinea',
      CODE_ER: 'Eritrea',
      CODE_EE: 'Estonia',
      CODE_ET: 'Ethiopia',
      CODE_FK: 'Falkland Islands (Malvinas)',
      CODE_FO: 'Faroe Islands',
      CODE_FJ: 'Fiji',
      CODE_FI: 'Finland',
      CODE_FR: 'France',
      CODE_GF: 'French Guiana',
      CODE_PF: 'French Polynesia',
      CODE_TF: 'French Southern Territories',
      CODE_GA: 'Gabon',
      CODE_GM: 'Gambia',
      CODE_GE: 'Georgia',
      CODE_DE: 'Germany',
      CODE_GH: 'Ghana',
      CODE_GI: 'Gibraltar',
      CODE_GR: 'Greece',
      CODE_GL: 'Greenland',
      CODE_GD: 'Grenada',
      CODE_GP: 'Guadeloupe',
      CODE_GU: 'Guam',
      CODE_GT: 'Guatemala',
      CODE_GG: 'Guernsey',
      CODE_GN: 'Guinea',
      CODE_GW: 'Guinea-Bissau',
      CODE_GY: 'Guyana',
      CODE_HT: 'Haiti',
      CODE_HM: 'Heard Island and McDonald Islands',
      CODE_VA: 'Holy See (Vatican City State)',
      CODE_HN: 'Honduras',
      CODE_HK: 'Hong Kong',
      CODE_HU: 'Hungary',
      CODE_IS: 'Iceland',
      CODE_IN: 'India',
      CODE_ID: 'Indonesia',
      CODE_IR: 'Iran, Islamic Republic of',
      CODE_IQ: 'Iraq',
      CODE_IE: 'Ireland',
      CODE_IM: 'Isle of Man',
      CODE_IL: 'Israel',
      CODE_IT: 'Italy',
      CODE_JM: 'Jamaica',
      CODE_JP: 'Japan',
      CODE_JE: 'Jersey',
      CODE_JO: 'Jordan',
      CODE_KZ: 'Kazakhstan',
      CODE_KE: 'Kenya',
      CODE_KI: 'Kiribati',
      CODE_KP: 'Korea, Democratic Peoples Republic of',
      CODE_KR: 'Korea, Republic of',
      CODE_KW: 'Kuwait',
      CODE_KG: 'Kyrgyzstan',
      CODE_LA: 'Lao Peoples Democratic Republic',
      CODE_LV: 'Latvia',
      CODE_LB: 'Lebanon',
      CODE_LS: 'Lesotho',
      CODE_LR: 'Liberia',
      CODE_LY: 'Libya',
      CODE_LI: 'Liechtenstein',
      CODE_LT: 'Lithuania',
      CODE_LU: 'Luxembourg',
      CODE_MO: 'Macao',
      CODE_MK: 'North Macedonia',
      CODE_MG: 'Madagascar',
      CODE_MW: 'Malawi',
      CODE_MY: 'Malaysia',
      CODE_MV: 'Maldives',
      CODE_ML: 'Mali',
      CODE_MT: 'Malta',
      CODE_MH: 'Marshall Islands',
      CODE_MQ: 'Martinique',
      CODE_MR: 'Mauritania',
      CODE_MU: 'Mauritius',
      CODE_YT: 'Mayotte',
      CODE_MX: 'Mexico',
      CODE_FM: 'Micronesia, Federated States of',
      CODE_MD: 'Moldova, Republic of',
      CODE_MC: 'Monaco',
      CODE_MN: 'Mongolia',
      CODE_ME: 'Montenegro',
      CODE_MS: 'Montserrat',
      CODE_MA: 'Morocco',
      CODE_MZ: 'Mozambique',
      CODE_MM: 'Myanmar',
      CODE_NA: 'Namibia',
      CODE_NR: 'Nauru',
      CODE_NP: 'Nepal',
      CODE_NL: 'Netherlands',
      CODE_NC: 'New Caledonia',
      CODE_NZ: 'New Zealand',
      CODE_NI: 'Nicaragua',
      CODE_NE: 'Niger',
      CODE_NG: 'Nigeria',
      CODE_NU: 'Niue',
      CODE_NF: 'Norfolk Island',
      CODE_MP: 'Northern Mariana Islands',
      CODE_NO: 'Norway',
      CODE_OM: 'Oman',
      CODE_PK: 'Pakistan',
      CODE_PW: 'Palau',
      CODE_PS: 'Palestine',
      CODE_PA: 'Panama',
      CODE_PG: 'Papua New Guinea',
      CODE_PY: 'Paraguay',
      CODE_PE: 'Peru',
      CODE_PH: 'Philippines',
      CODE_PN: 'Pitcairn',
      CODE_PL: 'Poland',
      CODE_PT: 'Portugal',
      CODE_PR: 'Puerto Rico',
      CODE_QA: 'Qatar',
      CODE_RE: 'Réunion',
      CODE_RO: 'Romania',
      CODE_RU: 'Russian Federation',
      CODE_RW: 'Rwanda',
      CODE_BL: 'Saint Barthélemy',
      CODE_SH: 'Saint Helena, Ascension and Tristan da Cunha',
      CODE_KN: 'Saint Kitts and Nevis',
      CODE_LC: 'Saint Lucia',
      CODE_MF: 'Saint Martin (French part)',
      CODE_PM: 'Saint Pierre and Miquelon',
      CODE_VC: 'Saint Vincent and the Grenadines',
      CODE_WS: 'Samoa',
      CODE_SM: 'San Marino',
      CODE_ST: 'Sao Tome and Principe',
      CODE_SA: 'Saudi Arabia',
      CODE_SN: 'Senegal',
      CODE_RS: 'Serbia',
      CODE_SC: 'Seychelles',
      CODE_SL: 'Sierra Leone',
      CODE_SG: 'Singapore',
      CODE_SX: 'Sint Maarten (Dutch part)',
      CODE_SK: 'Slovakia',
      CODE_SI: 'Slovenia',
      CODE_SB: 'Solomon Islands',
      CODE_SO: 'Somalia',
      CODE_ZA: 'South Africa',
      CODE_GS: 'South Georgia and the South Sandwich Islands',
      CODE_SS: 'South Sudan',
      CODE_ES: 'Spain',
      CODE_ES_CANARY: 'Spain - Canary Islands',
      CODE_LK: 'Sri Lanka',
      CODE_SD: 'Sudan',
      CODE_SR: 'Suriname',
      CODE_SJ: 'Svalbard and Jan Mayen',
      CODE_SZ: 'Swaziland',
      CODE_SE: 'Sweden',
      CODE_CH: 'Switzerland',
      CODE_SY: 'Syrian Arab Republic',
      CODE_TW: 'Taiwan',
      CODE_TJ: 'Tajikistan',
      CODE_TZ: 'Tanzania, United Republic of',
      CODE_TH: 'Thailand',
      CODE_TL: 'Timor-Leste',
      CODE_TG: 'Togo',
      CODE_TK: 'Tokelau',
      CODE_TO: 'Tonga',
      CODE_TT: 'Trinidad and Tobago',
      CODE_TN: 'Tunisia',
      CODE_TR: 'Turkey',
      CODE_TM: 'Turkmenistan',
      CODE_TC: 'Turks and Caicos Islands',
      CODE_TV: 'Tuvalu',
      CODE_UG: 'Uganda',
      CODE_UA: 'Ukraine',
      CODE_AE: 'United Arab Emirates',
      CODE_GB: 'United Kingdom',
      CODE_US: 'United States',
      CODE_UM: 'United States Minor Outlying Islands',
      CODE_UY: 'Uruguay',
      CODE_UZ: 'Uzbekistan',
      CODE_VU: 'Vanuatu',
      CODE_VE: 'Venezuela, Bolivarian Republic of',
      CODE_VN: 'Viet Nam',
      CODE_VG: 'Virgin Islands, British',
      CODE_VI: 'Virgin Islands, U.S.',
      CODE_WF: 'Wallis and Futuna',
      CODE_EH: 'Western Sahara',
      CODE_YE: 'Yemen',
      CODE_ZM: 'Zambia',
      CODE_ZW: 'Zimbabwe',
      CODE_XI: 'Northern Ireland',
    },
  },
  crossSell,
  onboarding: {
    pms: {
      title: 'Connect with your PMS',
      subtitle: 'Select your PMS, configure it, and test your check-in flow in minutes!',
      pmsConfiguration: 'PMS configuration',
      checkinForm: 'Check-in form',
      bookingSearch: 'Booking search',
      selectConfPms: 'Select and configure your PMS',
      selectConfPmsDescription:
        'Choose your PMS to connect with form the list below and configure it.',
      continue: 'continue',
    },
  },
  validation: {
    guest: {
      description:
        'Verify that guest data is stored correctly in the PMS and can be retrieved for the Paperless module.',
      bookingIdentifier: 'Booking number',
      activateCustomMock: 'Customize guest data',
      button: 'Test',
      response: {
        variableName: 'Variable',
        variablePMSName: 'Pms',
        civitfunData: 'Civitfun',
        pmsData: 'PMS',
      },
      guestType: {
        type: 'Guest type:',
        holder: 'Holder',
        adult: 'Adult',
        child: 'Child',
        guest: 'Guest:',
        domestic: 'Domestic',
        nonDomestic: 'Non-domestic',
      },
      warningChildDescription: 'It is mandatory that the reservation include a child.',
    },
    payment: {
      paymentTitle: 'Payment validation',
      description: 'Check the connection with the payment gateway:',
      bookingIdentifier: 'Booking number:',
      testPayment: 'Check connection',
      url: 'URL to access the payment gateway:',
    },
  },
  formFieldsInference: {
    button: 'Autocomplete field selection',
    description:
      'We will check your PMS for the fields you collect during guest check-in and automatically recommend them by selecting them in the form. This action will clear the current field selection.',
  },
  selector: {
    tabs: {
      onboardingTitle: 'Check-in Validation',
      onboardingDescription:
        'Validate the entire check-in process, ensuring the connection with the PMS, accurate reservation search, and data transfer between the PMS and Civitfun.',
      validationConection: 'Connection',
      validationSearches: 'Reservation Search',
      validationCodeSearch: 'PMS data recovery',
      validationSendData: 'Data Transfer to PMS',
      validationPayments: 'Payments',
      validationTestAll: 'Complete Check-in Flow',
      description:
        'Validate the entire check-in process, ensuring the connection with the PMS, accurate reservation search, and data transfer between the PMS and Civitfun.',
      results: 'Searches results',
      result: 'Search result',
      warning: 'Incomplete fields',
      warningDescription: 'Please enter the missing value in Booking locator and Date of entry.',
      warningGuestDescription:
        'Please enter the missing value in Booking number and/or Checkin date.',
    },
  },
  searchesResults: {
    searchByCodeResult: 'Search by Code',
    searchByEntranceDateResult: 'Search by Entrance date',
    searchByHolderNameResult: 'Search by Holder Name',
    searchByIdResult: 'Search by Id',
  },
  alertChangeModule: {
    title: 'Are you sure you want to {action} the {module} module for all hotels?',
    content: 'This action will {action} the {module} module for all hotels in the chain.',
    cancelMessage: 'Action cancelled',
  },
  pmsUdf: {
    title: 'File Management',
    form: {
      addUdf: 'Add custom field',
      editUdf: 'Edit custom field',
      name: 'Field name',
      field: 'Field in Civitfun',
      add: 'Add',
      edit: 'Save changes',
      cancel: 'Cancel',
    },
    table: {
      title: 'Custom Fields',
      id: 'ID',
      name: 'Name',
      referenceField: 'Reference field',
      edit: 'Edit',
      fieldType: 'Field type',
      keyword: 'Keyword',
    },
    deleteWarning: {
      title: 'Do you want to delete the custom field?',
      description:
        'This action cannot be undone. All data related to the selected custom field will be lost',
      remove: 'Delete custom field',
      cancel: 'Cancel',
    },
    removeError: 'Error deleting the custom field',
    removeSuccess: 'The custom field has been deleted',
    updateSuccess: 'The custom field has been updated',
    updateError: 'Error updating the custom field',
    createSuccess: 'The custom field has been created',
    createError: 'Error creating the custom field',
  },
  team: {
    newUser: 'ADD A NEW USER',
    newUserDetail: {
      name: 'Name',
      email: 'Email',
      hotel: 'Hotels',
      permission: 'Permission type',
      permissions: {
        owner: 'Owner',
        admin: 'Admin',
        adminDescription:
          'Administer the account, manage products and manage data, requests, and errors in the dashboards.',
        user: 'User',
        userDescription: 'Manage data, requests, and errors in the dashboards.',
        guest: 'Guest',
        guestDescription: 'View data, requests, and errors in the dashboards.',
      },
      invite: 'Invite',
      addNewUserToTeam: 'Invite a new member to the team',
    },
    users: 'USERS',
    usersDetail: {
      name: 'Name',
      email: 'E-mail',
      permission: 'Permission',
      status: 'Status',
      activeStatus: 'Created',
      pendingStatus: 'Pending',
      hotel: 'Hotels',
      actions: 'Actions',
      deletePop: 'Delete user',
      editPop: 'Edit user',
      deleteConfirmTitle: 'Are you sure you want to delete the user?',
      deleteConfirmDescription:
        'This action cannot be undone. All user data and permissions will be lost.',
      cancel: 'Cancel',
      delete: 'Delete user',
      deleteSuccess: 'User successfully deleted',
      deleteError: 'Error deleting user',
      edit: 'Edit user',
      editDescription: 'You can edit user information as well as settings and permissions.',
      editSuccess: 'User successfully edited',
      editError: 'Error editing user',
      save: 'Save changes',
      editOwnerRoleTitle: 'Owner Change Confirmation',
      editOwnerRoleDescription:
        'You are about to change the account owner. By doing so, the current Owner will be granted Admin permissions.',
      confirm: 'Confirm',
      blockedUser: 'Blocked',
      unblockUser: 'Unblock user',
      unblockUserSuccess: 'User successfully unblocked',
      unblockUserError: 'Error unblocking user',
    },
    viewRoles: {
      view: 'View',
      edit: 'Edit',
      permission: 'Permission',
      edit_users: 'Edit users',

      config: 'Configuration',
      manage_hotels: 'Manage hotels',
      config_pms: 'Manage PMS',
      forms: 'Forms',
      set_appearance: 'Manage appearance',
      subscriptions: 'Manage active modules',
      payments: 'Payments',
      doorOpening: 'Door opening',
      police_report_config: 'Police report configuration',
      legal_documents: 'Legal documents configuration',
      sftp_check_in: 'SFTP check-in documents',
      guestlink: 'Guestlink',
      paperless_push: 'Paperless push',
      resume: 'View summary',
      check_ins: 'View check-ins',
      reservations: 'View reservations',
      police_report_panel: 'Reports panel',
      marketing: 'Marketing',
      up_sell: 'Up-sell',
      cross_sell: 'Cross-sell',
      team: 'Team',
      billing: 'Billing',
    },
  },
  informationTexts: {
    langSelectorText: 'Select the language for the information texts',
    startCheckin: 'Information at the start of check-in',
    endCheckin: 'Information at the end of check-in',
    bookingNumber: 'Booking number',
    guestName: 'Guest name',
    entryDate: 'Check-in date',
    legalDocumentsInfo: 'Information in the legal documents',
    checkinButton: 'Check-in',
    continueButton: 'Finish check-in',
    defaultInfo: 'Default information',
    updateSuccess: 'The new text has been saved successfully.',
    updateError: 'Error saving the text.',
  },
  common: {
    bookingCode: 'Reservation number',
    holderName: 'Holder',
    entranceDate: 'Arrival date',
    checkIn: 'Check-in',
    pending: 'Pending',
    checkInAdults: 'Check-in adults',
    guestName: 'Guest name  ',
    selectYourHotel: 'Select your hotel',
    continue: 'Continue',
    bookingForm: 'Booking Form',
  },
  sftp: {
    configTitle: 'Check-In SFTP Configuration',
    protocol: 'Protocol',
    description:
      'Configure the SFTP repository where files generated during the check-in process will be automatically stored.',
    saveOk: 'Configuration saved successfully',
    saveError: 'Error saving configuration',
    connectionOk: 'Connection validated successfully',
    connectionError: 'Error validating connection.',
    missingSubscription: {
      description:
        "You can set up Check-in SFTP for the hotel by activating the 'SFTP Check-In files' license. Click the button below, and the Customer Success team will get in touch with you.",
    },
  },
  errorMessage: {
    noMatches: 'No reservations were found matching the filters',
    invalidStatusOnly: 'Reservations found, but none have a valid status',
    validationError: 'validation error. please check the input data.',
    unauthorized: 'unauthorized access. please check your credentials.',
    connectionRefused: 'forbidden. access to the resource is denied.',
    bookingNotFound: 'the requested resource was not found.',
    connectionTimeout: 'request timed out. please try again later.',
    reservationNotModified: 'conflict detected. unable to modify the reservation.',
    bookingsFountNoneMatch: 'Bookings were found, but none matched the provided booking.',
    apiGatewayError: 'Internal server error. Please contact support',
    connectionNoResponse: 'service unavailable. the server is not responding.',
  },
  formCopyCompatibility: {
    compatible: 'Compatible',
    notCompatible: 'Not compatible',
    incompatible_pms_no_dynamic_forms: 'The PMS of this hotel does not support dynamic forms',
    incompatible_no_pms: 'The hotel does not have a PMS configured',
    incompatible_different_form_versions: 'The hotel has a different form version',
    compatible_dynamic_different_pms:
      'This hotel has a different PMS, please review the configuration after copying',
    compatible_dynamic_to_legacy_different_pms:
      'This hotel has a different PMS and form version, please review the fields after copying',
    compatible_legacy_different_pms:
      'This hotel has a different PMS, please review the fields after copying',
  },
};
